import { apiCaller } from "../../../services/apiCaller"
import { API } from "../../../services/services"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { responseValidator } from "../../helpers"
import { useEffect } from "react"
import { setUserInfo } from "../../../redux/slices/userSlice"
import { conditions } from "../../conditions/conditions"
import { ConditionName, UserQuizStatus } from "../../../interfaces/enums"
import { setUserStatus } from "redux-share/slices/quizSlice";
import { shallowEqual } from 'react-redux'

const useGetProfile = () => {

    const dispatch = useAppDispatch();
    const { xToken } = useAppSelector(({ user: { xToken } }) => ({ xToken }), shallowEqual);
    const { isFetchDetails } = useAppSelector(({ videoData: { isFetchDetails } }) => ({ isFetchDetails }), shallowEqual);

    useEffect(() => {
        (async() => {
            if(conditions(ConditionName.getUserProfile)) {
                const { data, status } = await apiCaller({ url: API().user.profileWithXToken, method: "POST", data: { token: xToken } });
                if (responseValidator(status)) {
                    dispatch(setUserInfo(data.data));
                    if (conditions(ConditionName.hasQuizParams)) dispatch(setUserStatus(UserQuizStatus.participant));
                }
            }
        })()
    }, [isFetchDetails, xToken])
    
}

export default useGetProfile;